/**
 *  关于 api 枚举
 */
export enum EnumApiProduct {
  /** 商品详情 */
  productDetail = '/product/api/product/{productType}/{bizId}',
  productDetailByProductId = '/product/api/product/{productId}',
  productHasBuy = '/order/api/orders/hasbuy/product',
  ProductList = '/product/api/product/products',
  ProductListV2 = '/product/api/product/v2/products',
  ProductAgreement = '/product/api/product/{productId}/protoco',
  productCalendar = '/product/api/product/studycalendar',
  courseExistLive = '/course/api/course/live/exist',
  wenfangProductList = '/product/api/product/tool/bytool'
}
